import { ThemeUICSSObject } from '@apia/theme';

/**
 * El gridEdition tiene una estructura muy particular:
 *
 * Overlay > Modal > !!! iframe !!!
 *
 * iframe > ...
 *
 * Por este motivo no se pueden aplicar ni todos los estilos desde fuera
 * (overlay), ni todos los estilos desde dentro (document)
 *
 * @see
 *
 * iframeModal
 * layout.common.modals.iframeOverlay
 * layout.common.modals.gridEdition
 * layout.common.modals.overlayClassnames.gridEdition
 * layout.execution.form.editGrid
 */
const gridEdition: ThemeUICSSObject = {
  '&.gridEdition .modal__main': {
    height: '90vh',
    maxWidth: 'min(90vw, 992px)',
    maxHeight: '90vh',
    width: '100vw',
  },
};

export default gridEdition;
